import { FileThumbnaildGetDto } from "app/appModels";
import { AsyncUploadResult, FileGetDto } from "generated/CoreApi_v1";

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export type UploadingStatus = "none" | "uploading" | "uploaded" | "canceled";
export type UploadStatusChange = (status: UploadingStatus) => void;
export type UploadCallback = (data: AsyncUploadResult) => void;
export type UploadRemoveCallback = (data: FileThumbnaildGetDto) => void;

export function ConvertUploadToFileThumbnaildGetDto(upload: AsyncUploadResult): FileThumbnaildGetDto {
    const newFile: FileGetDto = {
        fileId: upload.mainFile.fileId,
        mimetype: upload.mainFile.mimetype,
        url: upload.mainFile.url,
        metadata: upload.mainFile.metadata,
    };

    const newThumb: FileGetDto | null =
        upload.thumbnail == null
            ? null
            : {
                fileId: upload.thumbnail.fileId,
                mimetype: upload.thumbnail.mimetype,
                url: upload.thumbnail.url,
                metadata: upload.thumbnail.metadata,
            };

    return { mainFile: newFile, thumbnail: newThumb, resizedImage: null };
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
